import axios from "../../../../utils/request"

function GET_LIST(params) {
    return  axios.post("/statistics/Index/productsNewsStatistics",{...params} )
}

function EXPORT(params) {
    return  axios.post("/statistics/Index/productsNewsStatisticsExport",{...params} )
}
function GET_INDUSTRY_LIST(params) {
    return  axios.get("/customer/ACustomer/getIndustryList",{
        params: {
            ...params
        }
    }  )
}
export default {
    GET_LIST,
    EXPORT,GET_INDUSTRY_LIST
}
